import { Record } from "immutable";

export const GuidePage = Record({
  id: null,
  experienceId: null,
  createdAt: null,
  updatedAt: null,
  content: null,
  title: null,
  position: null,
  isLive: false,
});

export const deserializeGuidePage = (fromRails) => {
  const {
    created_at: createdAt,
    updated_at: updatedAt,
    experience_id: experienceId,
    content,
    is_live: isLive,
    ...props
  } = fromRails;

  return GuidePage({
    ...props,
    createdAt,
    updatedAt,
    experienceId,
    isLive,
    content: content && JSON.parse(content),
  });
};

export const serializeGuidePage = (fromRecord) => {
  const { id, position, title, content, isLive, experienceId } = fromRecord.toJSON();

  return Object.assign(
    {
      id,
      position,
      title,
      is_live: isLive,
      experience_id: experienceId,
    },
    content && { content: JSON.stringify(content) }
  );
};
